var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-component"},[_c('div',{staticClass:"pg"},[_c('q-icon',{attrs:{"name":"fas fa-ban","size":"60px","color":"negative"}})],1),_c('div',[_vm._v("Sorry you do not have any "+_vm._s(_vm.name)+".")]),_c('div',[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }